import { z } from 'zod';

/**
 * 組織フォームのバリデーションスキーマ（作成・編集共通）
 *
 * 制約値は TenantDivisionCreateRequest / TenantDivisionUpdateRequest の OpenAPI 定義に準拠
 */
export const organizationsSchema = z.object({
  code: z.string().min(1).max(50),
  name: z.string().min(1).max(255),
  year: z.string().min(1),
});

export type OrganizationsFormValues = z.infer<typeof organizationsSchema>;
